import { useEffect, useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { getRelationsList } from 'services';
import { listSortPersonByName, errors } from 'helpers';
import { getPostsRoot } from 'redux/selectors';
import { useSelectorListState, useCreateDispatches } from 'helpers/hooks';
import useManageChildPermissions from './useManageChildPermissions';

export default function useManageChildSiblingsState() {
	const root = useSelector(getPostsRoot);
	const { childId } = useParams();
	const { push } = useHistory();
	const permissions = useManageChildPermissions();
	const [loaded, setLoaded] = useState(false);
	const [assignedSiblings, setAssignedSiblings] = useState([]);
	const childrenList = useSelector((state) => state.lifebooks.children);
	const { setSnackbarError, setLoader } = useCreateDispatches();

	const renderList = childId && !!permissions['sw'];

	const filteredChildrenList = childrenList?.filter(
		(child) => child?.id !== childId
	);

	const siblingInitialize = useCallback(
		async () => {
			selectorState.resetChanges();
		},

		// eslint-disable-next-line react-hooks/exhaustive-deps
		[push]
	);

	useEffect(() => {
		root && siblingInitialize(childId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [siblingInitialize]);

	useEffect(() => {
		const setSiblings = async () => {
			setLoader(true);
			setLoaded(false);
			if (childId && renderList) {
				try {
					const { data } = await getRelationsList(childId, 'sibling');
					setAssignedSiblings(listSortPersonByName(data));
				} catch (err) {
					setSnackbarError(
						{ response: err.response, ...errors.MANAGE_CHILD_SW_REL },
						{ log: true }
					);
				}
			}
			setLoaded(true);
			setLoader(false);
		};
		setSiblings();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [childId]);

	const selectorState = useSelectorListState(
		filteredChildrenList,
		assignedSiblings,
		{
			loaded,
		}
	);

	return {
		selectorState,
		siblingInitialize,
	};
}
